import { render, staticRenderFns } from "./OrderList.vue?vue&type=template&id=86a854b0&"
import script from "./OrderList.vue?vue&type=script&lang=js&"
export * from "./OrderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('86a854b0')) {
      api.createRecord('86a854b0', component.options)
    } else {
      api.reload('86a854b0', component.options)
    }
    module.hot.accept("./OrderList.vue?vue&type=template&id=86a854b0&", function () {
      api.rerender('86a854b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/sale/order/OrderList.vue"
export default component.exports